// extracted by mini-css-extract-plugin
module.exports = {"angle":"Pagination_angle__2gEJB","invertedPagination":"Pagination_invertedPagination__2o08H"};